import { useState, useEffect, useMemo } from 'react';
import { getStringOfTime } from './utils';

// مرکزی‌سازی تایمر: یک setInterval واحد برای کل اپلیکیشن
const listeners = new Set();
let centralIntervalId = null;

function startCentralTimer() {
    if (centralIntervalId === null) {
        centralIntervalId = setInterval(() => {
            const now = Date.now();
            listeners.forEach((callback) => {
                try {
                    callback(now);
                } catch (e) {
                    console.error("Timer listener error:", e);
                }
            });
        }, 1000);
    }
}

function stopCentralTimer() {
    if (centralIntervalId !== null && listeners.size === 0) {
        clearInterval(centralIntervalId);
        centralIntervalId = null;
    }
}

function subscribeToCentralTimer(callback) {
    listeners.add(callback);
    startCentralTimer();
    return () => {
        listeners.delete(callback);
        stopCentralTimer();
    };
}

/**
 * هوک شمارش معکوس برای کارت‌های شگفت‌انگیز
 * @param {string|Date} incredibleDate تاریخ شروع شگفت‌انگیز
 * @param {number} intervalHours مدت زمان انقضا بر حسب ساعت (پیش‌فرض ۵۰ ساعت)
 * @returns {{ hours: string, minutes: string, seconds: string, text: string } | null}
 */
export function useIncredibleCountdown(incredibleDate, intervalHours = 50) {
    const expireTime = useMemo(() => {
        if (!incredibleDate) return null;
        try {
            const d = new Date(incredibleDate);
            const hoursToAdd = Number(intervalHours) || 50;
            d.setHours(d.getHours() + hoursToAdd);
            return d.getTime();
        } catch {
            return null;
        }
    }, [incredibleDate, intervalHours]);

    const calculateTime = useMemo(() => {
        return (now = Date.now()) => {
            if (!expireTime) return null;
            const distance = expireTime - now;
            if (distance <= 0) return null;

            const hours = Math.floor(distance / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            const hStr = getStringOfTime(hours);
            const mStr = getStringOfTime(minutes);
            const sStr = getStringOfTime(seconds);

            return {
                hours: hStr,
                minutes: mStr,
                seconds: sStr,
                text: `${hStr}:${mStr}:${sStr}`
            };
        };
    }, [expireTime]);

    const [timerParts, setTimerParts] = useState(() => calculateTime());

    useEffect(() => {
        if (!expireTime) {
            setTimerParts(null);
            return;
        }

        // محاسبه اولیه فوری
        setTimerParts(calculateTime());

        // عضویت در تایمر مرکزی با جلوگیری از رندرهای بیهوده در صورت عدم تغییر ثانیه
        const unsubscribe = subscribeToCentralTimer((now) => {
            const next = calculateTime(now);
            setTimerParts(prev => {
                if (!prev && !next) return null;
                if (prev && next && prev.text === next.text) return prev;
                return next;
            });
        });

        return unsubscribe;
    }, [expireTime, calculateTime]);

    return timerParts;
}
